import * as React from 'react';
export default function isMuiElement(element, muiNames) {
  return React.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/utils/isMuiElement.js
// module id = 209
// module chunks = 1